// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_2GHxt","locked":"index_locked_fU8xV"};